import { APPARITIONS } from "./apparitions";
import { FATIMA_LIBRARY_PRAYERS } from "./fatimaPrayers";
import { SHRINE_PRAYER_AUDIT } from "./shrinePrayerAudit";
import { SUB_TUUM } from "./historicalPrayers";

export const PRAYER_AUTHENTICITY_LABELS = {
  traditional: "Historical prayer · cited edition",
  reported: "Reported invocation · official source",
  supplied: "Reported prayer · supplied translation",
  papal: "Papal prayer · supplied wording",
  published: "Published prayer · publisher edition",
};

const createPrayers = (entry) => {
  const audit = SHRINE_PRAYER_AUDIT[entry.id];
  const base = { apparitionId: entry.id, apparitionTitle: entry.title, cat: entry.id === "fatima" ? "fatima" : "apparitions" };
  const rows = [];
  if (entry.featuredPrayer) {
    const p = entry.featuredPrayer;
    rows.push({ ...base, ...p, title: `${p.title} · ${p.author}`, displayTitle: p.title, subtitle: p.author,
      origin: "Papal prayer · user-supplied wording", authenticity: "papal", tag: "Papal prayer", featured: p,
      lines: [["English", p.text]], sourceNote: "The wording supplied by the reader is preserved. The linked publication attributes the prayer to St. John Paul II; it is not a prayer dictated during the 1531 apparitions." });
  }
  if (entry.id === "fatima") {
    rows.push(...FATIMA_LIBRARY_PRAYERS.map((p) => ({ ...base, ...p, authenticity: "supplied" })));
  } else if (entry.id === "miraculous-medal") {
    const text = "O Mary conceived without sin, pray for us who have recourse to you.";
    rows.push({ ...base, id: "miraculous-medal-invocation", title: "The Miraculous Medal invocation", subtitle: "The inscription reported on 27 November 1830",
      origin: "Official chapel account of the apparition to St. Catherine Labouré", authenticity: "reported", tag: "Reported invocation",
      text, lines: [["English", text]], sourceUrl: audit.checkedUrl, sourceLabel: "Official chapel · the reported inscription",
      sourceNote: "This is the short inscription documented by the chapel. The former extended petition is not presented as words included in that inscription." });
  } else if (!entry.featuredPrayer) {
    rows.push({ ...base, ...SUB_TUUM, id: `shrine-${entry.id}-original`, audioId: SUB_TUUM.id,
      subtitle: `A traditional Marian prayer · for prayer at ${entry.short}`,
      origin: SUB_TUUM.sourceLabel, authenticity: "traditional", tag: "Historical prayer",
      lines: [["English", SUB_TUUM.text]],
      sourceNote: "This historical Marian prayer replaces the former website-written text. It is not a prayer dictated at this apparition or a shrine-specific formula. Local publisher editions are linked separately." });
  }
  rows.push(...audit.resources.map((p) => ({ ...base, ...p, subtitle: `${p.language} · full text at the publisher`, origin: p.publisher,
    tag: "Published prayer", lines: [], sourceNote: "The full publisher edition is linked, not transcribed or translated here. A published devotion is not automatically an apparition quotation." })));
  return rows;
};

export const APPARITION_PRAYERS = APPARITIONS.flatMap(createPrayers);
export const APPARITION_PRAYER_SHRINES = APPARITIONS.map((e) => ({ id: e.id, title: e.title }));
export const prayersForApparition = (id) => APPARITION_PRAYERS.filter((p) => p.apparitionId === id);